import React, { FC } from 'react';
import { LanguageSwitcher } from 'components/LanguageSwitcher';
import { getAppSettings } from 'common/settings';

export const Header: FC = () => {
  return (
    <div className="header">
      <a className="header__logo" href={getAppSettings().landingUrl} target="_blank" rel="noopener noreferrer">
        <span>hvala.</span>

        <span>tips</span>
      </a>

      <LanguageSwitcher />
    </div>
  );
};
